import {COACH_PEBBLE_ROLE_CUSTOM_CLAIM, UserPermission} from '@cp/model';
import {User} from 'firebase/auth';
import {firebaseAuth} from './firebase';

export async function getCurrentUser(): Promise<User | null> {
  return firebaseAuth.currentUser;
}

export async function getCurrentUserRoles(): Promise<UserPermission[]> {
  const tokenResult = await firebaseAuth.currentUser?.getIdTokenResult();
  return tokenResult?.claims[COACH_PEBBLE_ROLE_CUSTOM_CLAIM] as UserPermission[];
}

export async function getCurrentUserId(): Promise<string | undefined> {
  return firebaseAuth.currentUser?.uid;
}

export async function getCurrentUserIdValidated(): Promise<string> {
  const uid = await getCurrentUserId();
  if (!uid) throw new Error('Not authenticated');
  return uid;
}
